var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/feedback") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "82.5210101%",
    x2: "79.3721548%",
    y2: "16.3368701%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/feedback",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2798,83.7548 L174.2528,96.7948 C176.5818,99.1358 176.5818,102.4798 174.2528,104.8198 C171.9238,107.1588 168.5968,107.1588 166.2698,104.8198 L163.9998,101.9998 L163.9998,133.9998 C163.9998,140.6198 158.6488,145.9448 152.0628,145.9448 L136.3298,145.9448 C136.0748,145.9448 135.8338,145.9358 135.5928,145.9268 L99.9998,145.9998 C83.0338,145.9998 51.9998,169.9998 51.9998,169.9998 L51.9998,145.9998 L35.9998,145.9998 C32.7068,145.9998 27.9998,141.3108 27.9998,137.9998 L27.9998,101.9998 C27.9998,93.9998 39.9998,93.9998 39.9998,101.9998 L39.9998,133.9998 L55.9998,133.9998 L64.9268,133.8898 L64.9268,147.6028 C77.3588,138.3838 90.9758,133.9998 99.9998,133.9998 L143.9998,133.9998 C143.9888,133.9978 152.0028,133.8678 152.0098,133.8548 L152.0728,133.8548 C152.0918,133.6238 151.9998,125.7068 151.9998,101.9998 L150.3018,104.8198 C147.9728,107.1588 143.6478,107.6608 141.3208,105.3218 C138.9898,102.9808 138.9898,99.1358 141.3208,96.7948 L153.2958,83.7548 C155.6228,81.4148 158.9498,81.4148 161.2798,83.7548 Z M112,89 C119,89 124,94 124,101 L124,109 C120.5,112.5 107.243,117 96,117 C84.758,117 71.5,112.5 68,109 L68,101 C68,94 73,89 80,89 L112,89 Z M155.9997,21.9997 C159.9997,21.9997 163.9997,25.9997 163.9997,29.9997 L163.9997,61.9997 C163.9997,69.9997 151.9997,69.9997 151.9997,61.9997 L151.9997,33.9997 L136.8787,34.0767 L136.5567,34.0767 C135.7297,34.1227 134.9647,34.1197 134.2507,34.0767 L39.9922,34.0767 L39.991664,34.089758 C39.94517,34.69067 39.7127,38.8133 39.7127,61.1747 L41.7087,59.1677 C44.0387,56.8257 48.3657,56.3247 50.6947,58.6657 C53.0237,61.0077 53.0237,64.8547 50.6947,67.1967 L38.7137,80.2437 C36.3847,82.5847 33.0557,82.5847 30.7267,80.2437 L17.7477,67.1967 C15.4177,64.8547 15.4177,61.5087 17.7477,59.1677 C20.0767,56.8257 23.4057,56.8257 25.7347,59.1677 L27.7317,61.1747 L27.9997,33.9997 C27.9997,27.3757 33.4097,21.9997 39.9997,21.9997 L133.5047,22.0337 C134.1397,21.9907 134.8207,21.9877 135.5577,22.0337 L155.0127,22.0337 L155.9997,21.9997 Z M96,48.417 C104.836,48.417 112,55.581 112,64.417 C112,73.254 104.836,80.417 96,80.417 C87.164,80.417 80,73.254 80,64.417 C80,55.581 87.164,48.417 96,48.417 Z",
    id: "Logo",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "9a165d95e03ff464a23246fbfa62e641.svg";
export { ForwardRef as ReactComponent };